import React from 'react';
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap';
import { Dialog } from 'primereact/dialog';

export const DeleteExam = (props) => {

    const { toggle, loading, code, alias, name, saveDelete } = props;

    return (
        <Form role="form" onSubmit={saveDelete}>
            <ModalBody >
                <div style={{ textAlign: 'center', marginBottom: '1.2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                    <i className="fa fa-exclamation-triangle" style={{ fontSize: '1.5rem', color: '#ffdb0dff' }}></i>
                    <h5 style={{ fontWeight: 'bold', fontSize: '13px', margin: 0 }}>
                        ¡Estás a punto de eliminar este examen!
                    </h5>
                </div>
                <div style={{ marginBottom: '1.5rem', padding: '0.75rem 1rem', backgroundColor: '#ffe5e5', borderRadius: '6px' }}>
                    <p style={{ fontSize: '13px', margin: '0.25rem 0' }}>
                        <strong>Nombre:</strong> {name}
                    </p>
                    <p style={{ fontSize: '13px', margin: '0.25rem 0' }}>
                        <strong>Código:</strong> {code}
                    </p>
                    <p style={{ fontSize: '13px', margin: '0.25rem 0' }}>
                        <strong>Alias:</strong> {alias}
                    </p>
                </div>

                <div style={{ textAlign: 'center' }}>
                    <h6 style={{ fontWeight: 'bold', fontSize: '13px', color: '#a70000', margin: 0 }}>
                        ¿Estás seguro de hacerlo?
                    </h6>
                </div>
            </ModalBody>

            <ModalFooter>
                <Button
                    outline
                    color="primary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Si,eliminar
                </Button>
                <Button outline color='danger' type="button" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Form>
    )
}
